import React from 'react';
import { ChevronRight, Play } from 'lucide-react';
import TanpuraAnimation from './TanpuraAnimation';
import FadeIn from './FadeIn';

const Hero: React.FC = () => {
  return (
    <section id="about" className="relative min-h-screen flex items-center pt-20 overflow-hidden">
      {/* Background Decorative Elements */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-sand/30 -skew-x-12 transform translate-x-20 z-0" />
      
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center relative z-10 w-full">
        {/* Left Content */}
        <div className="space-y-8">
            <FadeIn delay={100}>
                <span className="inline-block py-1 px-3 border border-royal-maroon/30 rounded-full text-royal-maroon text-xs tracking-[0.2em] uppercase font-medium mb-4">
                    Honoring Tradition. Inspiring Mastery.
                </span>
                <h1 className="font-display text-4xl md:text-7xl leading-tight text-gray-900 font-semibold">
                    Learn The Divine Art of <br />
                    <span className="text-royal-maroon text-5xl md:text-8xl italic font-bold block mt-2">Carnatic Music</span>
                </h1>
            </FadeIn>
            
            <FadeIn delay={300}>
                <p className="text-lg text-gray-600 max-w-md leading-relaxed font-light">
                    Experience the soulful heritage of South Indian classical music. 
                    At Swaram Academy, we preserve ancient traditions while nurturing the artists of tomorrow through disciplined sadhana.
                </p>
            </FadeIn>

            <FadeIn delay={500} className="flex flex-wrap gap-4 pt-4">
                <a 
                    href="#curriculum"
                    className="group flex items-center gap-2 px-8 py-4 bg-royal-maroon text-white rounded hover:bg-royal-maroon-light transition-all shadow-xl shadow-royal-maroon/20 hover:shadow-2xl hover:-translate-y-1"
                >
                    <span className="tracking-wide font-medium">Start Learning</span>
                    <ChevronRight size={18} className="group-hover:translate-x-1 transition-transform" />
                </a>
                <button className="flex items-center gap-3 px-8 py-4 bg-white border border-gray-200 text-gray-800 rounded hover:border-royal-maroon/50 hover:text-royal-maroon transition-all">
                    <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center">
                         <Play size={12} fill="currentColor" className="ml-0.5" />
                    </div>
                    <span className="tracking-wide font-medium">Watch Demo</span>
                </button>
            </FadeIn>

            <FadeIn delay={700}>
                <div className="flex items-center gap-8 mt-8 border-t border-gray-200 pt-8">
                    <div>
                        <p className="text-3xl font-display text-royal-maroon">Offline and Online</p>
                        <p className="text-xs text-gray-500 uppercase tracking-wider mt-1">Classes</p>
                    </div>
                </div>
            </FadeIn>
        </div>

        {/* Right Content - Visual */}
        <FadeIn delay={200} className="hidden md:flex justify-center items-center h-full">
           <div className="relative">
                {/* A subtle circle behind the instrument */}
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] border border-royal-maroon/10 rounded-full animate-[spin_60s_linear_infinite]" />
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[350px] h-[350px] border border-dashed border-royal-maroon/20 rounded-full animate-[spin_40s_linear_infinite_reverse]" />
                <TanpuraAnimation />
           </div>
        </FadeIn>
      </div>
    </section>
  );
};

export default Hero;